import keyBy from 'lodash/keyBy';
import { addStar, deleteStar, fetchStar, fetchStars } from './stars.utils';

let loadAllPromise;

const stars = {
    namespaced: true,
    state: {
        error: {},
        fetching: false,
        map: {},
    },
    mutations: {
        setFetching (state, { isFetching }) {
            state.fetching = isFetching;
        },
        setMap (state, { map }) {
            state.map = map;
        },
        setMapAtKey (state, { id, star }) {
            state.map[id] = star;
        },
        deleteByKey (state, { id }) {
            delete state.map[id];
        },
        setError (state, { error }) {
            state.error = error;
        },
    },
    actions: {
        async loadAll ({ commit }, { reFetch = false } = {}) {
            if (loadAllPromise && reFetch !== true) {
                await loadAllPromise;

                return;
            }

            commit('setFetching', { fetching: true });
            loadAllPromise = fetchStars();

            try {
                let { data: stars } = await loadAllPromise;
                stars = stars.map((starObj) => ({ ...starObj, starred: true }));
                commit('setMap', { map: keyBy(stars, 'itemId') });
                commit('setFetching', { fetching: false });
            } catch (error) {
                loadAllPromise = null;
                commit('setError', { error });
                commit('setFetching', { fetching: false });
                throw error;
            }
        },
        async loadOne ({ commit, getters }, { itemId: id, reFetch = false }) {
            const star = getters.getStarByItemId(id);
            if (star && !reFetch) return Promise.resolve();

            commit('setFetching', { fetching: true });

            try {
                const { data: star } = await fetchStar(id);
                commit('setFetching', { fetching: false });
                commit('setMapAtKey', { id, star });
            } catch (error) {
                commit('setFetching', { fetching: false });
                commit('setError', { error });
                throw error;
            }
        },
        addNow ({ commit }, payload) {
            try {
                const star = {
                    itemId: payload.id,
                    itemType: payload.type,
                    starred: true,
                };
                commit('setMapAtKey', { id: payload.id, star });

                return addStar({ itemType: payload.type, itemId: payload.id });
            } catch (error) {
                commit('deleteByKey', { id: payload.id });
                throw error;
            }
        },
        removeNow ({ commit }, payload) {
            try {
                commit('deleteByKey', { id: payload.id });

                return deleteStar({ itemType: payload.type, itemId: payload.id });
            } catch (error) {
                const star = {
                    itemId: payload.id,
                    itemType: payload.type,
                    starred: true,
                };
                commit('setMapAtKey', { id: payload.id, star });
                throw error;
            }
        },
    },
    getters: {
        map: (state) => state.map,
        isStarredById: (state) => (id) => {
            return !!state.map[id]?.starred;
        },
        getStarByItemId: (state) => (itemId) => {
            return state.map[itemId];
        },
        getStarsByKind: (state) => (kind) => {
            if (state.fetching) return [];

            return Object.values(state.map).filter((star) => star.itemType === kind);
        },
    },
};

export default stars;

export function __resetLoadAllPromiseForUnitTests () {
    loadAllPromise = null;
}
